import React from 'react';
import Field from './field';
import { observer } from 'mobx-react';

export default observer((props) => {
    const { fieldKey, defaultValue, register } = props;
    const addrs = {
        _id: fieldKey,
        name: fieldKey
    };

    return (
        <Field
            {...props}
            inputComp={
                <textarea {...addrs} {...register}>
                    {defaultValue}
                </textarea>
            }
        />
    );
});
